import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ManageBannerService } from '../manage-banner.service';
import { TCCPConstantValues } from '../../../shared/models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { TCCPCommonService } from '../../../shared/services/tccp-common.service';
import { Banner } from '../../../shared/models/Banner';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TCCPLocalStorageService } from '../../../shared/services/tccp-local-storage.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AdminService } from '../../admin.service';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import _ from 'lodash';
import { PreviewBannerDialogComponent } from '../manage-banner.component';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-draft-banner-list',
  templateUrl: './draft-banner-list.component.html',
  styleUrls: ['./draft-banner-list.component.scss']
})
export class DraftBannerListComponent implements OnInit {

  public bannerStatusList = [];
  public bannerStatus = 'Draft';
  public pageTitle = 'Manage Banner';

  @ViewChild(MatSort, { static: false  }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false  }) paginator: MatPaginator;
  selection = new SelectionModel< Banner >(true, []);
  public selectedApplication: string = this.adminService.selectedApplication;
  public bannerList: Banner[] = [];
  public bannerDataSource = new MatTableDataSource([]);
  public isPermissionExists = false ;
  public displayedColumns: string[] = [];
  public success = [];
  public failure = [];
  public alerts = [];
  public banner: Banner = < Banner > {};

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router, private bannerService: ManageBannerService,
    private storageService: TCCPLocalStorageService, private authService: MsalService,
    private adminService: AdminService, private dialog: MatDialog, public commonService: TCCPCommonService) {
    this.bannerStatus = 'Draft';
  }

  ngOnInit() {
    this.setUserPolicy();
    this.success = [];
    this.failure = [];
    this.alerts = [];
    this.getBanners('Draft');
  }

  async setUserPolicy(): Promise< void > {
    if (!this.storageService.getRoles()){
      const upn = this.storageService.getUpn();
      await this.commonService.getUserAccessRole(upn).then(data => {
        this.storageService.setRoles(_.map(data,'roles'));
      });
    } 
  }

  previewBanner() {
    environment.applicationName = this.adminService.selectedApplication;
    this.commonService.hideBanner.emit(false);
    this.storageService.setbannerCloseStatus(false);
    if (this.selection.selected.length > 1) {
      this.showAlertMessages('error', 'Please select one Banner to see Preview');
    } else {
      this.storageService.setPreviewFromPublish(true);
      const dialogRef = this.dialog.open(PreviewBannerDialogComponent, {
        id: environment.applicationName + '-preview-dialog-container',
        height: '98%',
        width: '100vw',
        maxWidth: '95vw',
        panelClass: 'full-screen-modal',
        position: { top: '10px' },
        data: this.selection.selected[0]
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }


  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  public getBanners(status: string) {
    this.bannerService.getBanner(this.selectedApplication, status).subscribe(response => {
      if (response) {
        const roles = this.storageService.getRoles();
        this.displayedColumns = ['select', 'title',
          'contentType', 'category', 'createdBy', 'createdAt'];

        this.isPermissionExists = roles && roles[0] && roles[0].indexOf('CTContentPublisherUser') > -1;
        if (this.isPermissionExists) {
          this.displayedColumns.push('action');
        }
        this.bannerList = response;
        this.bannerDataSource.data = [];
        response.map(x => {
          const formattedJSON: Banner = < Banner > {};
          const formattedArray = [];
          formattedJSON.title = x.title;
          formattedJSON.contentType = x.contentType;
          formattedJSON.createdAt = x.createdAt;
          formattedJSON.category = x.category;
          formattedJSON.division = x.division;
          formattedJSON.content = x.content;
          formattedJSON.createdBy = x.createdBy;
          formattedJSON.id = x.id;
          formattedJSON.status = x.status;
          formattedArray.push(formattedJSON);
          this.bannerDataSource.data.push(formattedJSON);
        });

        setTimeout(() => {
          let sortedContents = [];
          sortedContents = this.bannerDataSource.data.sort((obj1, obj2) =>
            obj1.createdAt < obj2.createdAt ? 1 : -1);
          this.bannerDataSource.data = sortedContents;
          this.bannerDataSource.sort = this.sort;
          this.bannerDataSource.paginator = this.paginator;
          this.cdr.detectChanges();
        });

        this.bannerDataSource.filterPredicate = (data: any, filter) => {
          const dataStr = JSON.stringify(data).toLowerCase();
          return dataStr.indexOf(filter) !== -1;
        };
      }
    });
  }

  applyFilter(filterValue: string) {
    this.bannerDataSource.filter = filterValue.trim().toLowerCase();
  }

  onEdit(row) {
    this.bannerService.pageMode = 'edit';
    this.bannerService.selectedBanner = row;
    this.router.navigateByUrl('/admin/add-banner');
  }

  onDelete(row) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.BANNER_DELETE_CONFIRMATION_MESSAGE
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bannerService.deleteBanner(row.id, this.selectedApplication).subscribe(response => {
          if (response) {
            this.showAlertMessages('success', TCCPConstantValues.admin.messages.BANNER_DELETE_SUCCESS_MESSAGE);
            this.getBanners('Draft');
          }
        });
      }
    });
  }

  public goToAddBanner() {
    this.bannerService.pageMode = 'add';
    this.router.navigateByUrl('/admin/add-banner');
  }

  statusDialog() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE,
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  moveToPublish() {
    this.success = [];
    this.failure = [];
    this.alerts = [];
    const selectedBannerList = this.selection.selected.map(x => x.id);
    const selectedBannerTypeList = this.selection.selected.map(x => x.contentType);
    let hasPublishedBanner = false ;
    if (selectedBannerTypeList.indexOf('Both') > -1 && selectedBannerTypeList.length > 1) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
    } else {
      if (selectedBannerTypeList.length === _.uniq(selectedBannerTypeList).length) {
        this.bannerService.getBanner(this.selectedApplication, 'Publish').subscribe(response => {
          if (response) {
            const publishedBannerTypeList = response.map(x => x.contentType);
            selectedBannerTypeList.forEach(x => {
              if (x === 'Both' && publishedBannerTypeList.length > 0) {
                hasPublishedBanner = true;
                this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
              } else {
                if (!hasPublishedBanner) {
                  if (publishedBannerTypeList.indexOf('Both') > -1 || publishedBannerTypeList.indexOf(x) > -1) {
                    if (!hasPublishedBanner) {
                      hasPublishedBanner = true;
                    }
                  }
                }
              }
            });
            if (!hasPublishedBanner) {
              this.callUpdateStatus(selectedBannerList, this.bannerStatus);
            } else {
              this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
            }
          }
        });
      } else {
        this.showAlertMessages('error', TCCPConstantValues.admin.messages.BANNER_PUBLISH_CONFIRMATION_MESSAGE);
      }
    }
  }

  callUpdateStatus(selectedBannerList, status) {
    const bannerStatus = 'Publish';
    const requestParameter = { bannerIds: selectedBannerList, userid: this.authService.instance.getActiveAccount().username };
    this.bannerService.updateStatus(requestParameter, this.selectedApplication, bannerStatus).subscribe(data => {
      if (data) {
        if (data === '{}') {
          this.selection.selected.forEach(element => {
            this.success.push({
              banner: element.title,
              msg: 'The following Banner(s) are succesfully Published.'
            });
          });
          this.selection = new SelectionModel< Banner >(true, []);
          this.getBanners('Draft');
        } else {
          this.selection.selected.forEach(element => {
            this.failure.push({
              banner: element.title,
              msg: 'Error While Updating status for the following Banner(s)'
            });
          });
        }
      }
    });
  }

}
